import { Box, Typography, Hidden, Grid, Stack } from '@mui/material';
import Images from '../utils/Images';
import BestCouponSkeleton from './SkeletonComponents/BestCouponSkeleton';

export const getBestCouponDisplay = (product, coupon, isExcludedFromCoupon) => {
  if (!product) return null;

  const mrp = Number(product?.newMrp || 0);
  const offerPrice = Number(product?.newOfferPrice || 0);

  if (!coupon || isExcludedFromCoupon) {
    const baseDiscountPercent =
      mrp > 0 ? ((mrp - offerPrice) / mrp) * 100 : 0;

    return {
      type: "default",
      displayPrice: Math.ceil(offerPrice),
      discountPercentOnMrp: baseDiscountPercent,
      displayDiscountPercent: baseDiscountPercent,
      saveAmount: Math.max(0, Math.ceil(mrp - offerPrice)),
      offLabel: `${baseDiscountPercent.toFixed(0)}% Off`,
    };
  }

  let discountedPrice = null;
  let displayDiscountPercent = 0;

  if (coupon?.isMrpDiscount && coupon?.discountPercent) {
    discountedPrice = mrp * (1 - Number(coupon.discountPercent) / 100);
    displayDiscountPercent = Number(coupon.discountPercent);
  } else if (coupon?.discountPercent) {
    discountedPrice =
      offerPrice - (Number(coupon.discountPercent) / 100) * offerPrice;
    displayDiscountPercent = Number(coupon.discountPercent);
  } else if (coupon?.discountAmount) {
    discountedPrice = offerPrice - Number(coupon.discountAmount);
    displayDiscountPercent =
      offerPrice > 0
        ? (Number(coupon.discountAmount) / offerPrice) * 100
        : 0;
  } else if (coupon?.discountPrice) {
    discountedPrice = Number(coupon.discountPrice);
    displayDiscountPercent =
      offerPrice > 0
        ? ((offerPrice - discountedPrice) / offerPrice) * 100
        : 0;
  }

  if (discountedPrice === null || isNaN(discountedPrice)) return null;

  discountedPrice = Math.max(0, discountedPrice);

  const discountPercentOnMrp = mrp > 0 ? ((mrp - discountedPrice) / mrp) * 100 : 0;

  return {
    type: "coupon",
    displayPrice: Math.ceil(discountedPrice),
    discountPercentOnMrp,
    displayDiscountPercent,
    saveAmount: Math.max(0, Math.ceil(offerPrice - discountedPrice)),
    offLabel: `${displayDiscountPercent.toFixed(0)}% Off`,
  };
};

const ProductCard = ({ product, quantityInCart, handleProductClick, matchesMdUp, isLastInRow, isLastRow, coupon, isFetchingBestCoupon }) => {

  const outletData = JSON.parse(localStorage.getItem("selectedStoreData"));
  const token = localStorage.getItem("token");

  const isFreebie = coupon?.isFreebieCoupon === true;

  const isManuallyExcluded = Array.isArray(coupon?.manuallyExcludedProducts) &&
    coupon.manuallyExcludedProducts.some(id => String(id) === String(product?._id));

  const isExcluded = Array.isArray(coupon?.excludedProducts) &&
    coupon.excludedProducts.some(id => String(id) === String(product?._id));

  const isExcludedFromCoupon = isFreebie || isManuallyExcluded || isExcluded;

  const bestCouponDisplay = getBestCouponDisplay(product, coupon, isExcludedFromCoupon);

  const getCouponTheme = (bestCouponDisplay, product) => {
    const percent = Number(bestCouponDisplay?.displayDiscountPercent || 0);
    const hasCouponApplied = bestCouponDisplay?.type === "coupon";

    if (product?.isIntroductoryFlag) {
      return {
        amount: '#00A9FC',
        offText: '#00A9FC',
        offBg: '#FBED20',
      };
    }

    // Combo should be green ONLY when no coupon is applied
    if (product?.classType === 'COMBOS' && !hasCouponApplied) {
      return {
        amount: '#2e7d32',
        offText: '#fff',
        offBg: '#2e7d32',
      };
    }

    // If coupon exists, treat combo like normal products
    if (percent >= 20) {
      return {
        amount: '#c62828',
        offText: '#fff',
        offBg: '#c62828',
      };
    }

    return {
      amount: '#00A9FC',
      offText: '#fff',
      offBg: '#00A9FC',
    };
  };

  const theme = getCouponTheme(bestCouponDisplay, product);

  return (
    <Box key={product?._id}
      sx={{
        ...(matchesMdUp ? { borderRight: isLastInRow ? 'none' : '1px dashed #D6D6D6' } : { borderRight: 'none', borderLeft: 'none', }),
        borderBottom: isLastRow ? 'none' : '1px dashed #D6D6D6',
        ...(matchesMdUp ? {} : {
          // borderBottom: productIndex === category.products.length - 1 ? 'none' : '1px dashed #6a6a6a',
          borderBottom: isLastRow ? 'none' : '1px dashed #D6D6D6',
          // borderImage: 'repeating-linear-gradient(90deg, #D6D6D6, #D6D6D6 10px, transparent 10px, transparent 14px) 2',
        }),
      }}
      className={`product-item ${product?.isExhausted ? 'exhausted' : ''}`}
    >

      <Hidden smUp>
        <Grid container onClick={() => handleProductClick(product)}>
          <Grid item xs={4} sm={4} className="imageBox" onClick={() => handleProductClick(product)}>
            <img className="image" src={product?.displayImageUrl} alt="Product" />
          </Grid>
          <Grid item xs={8} sm={8}>
            <Typography className="productName">{product?.name}</Typography>

            <Box display={'flex'} justifyContent={'space-between'} alignContent={'center'}>

              <Box className="productPrice">
                <>
                  {product?.foodType === 'VEG/VEGAN' ? (
                    <Stack direction={'row'}>
                      <img className='veg-nonveg' src={Images.veg} alt='veg' />
                      <img style={{ height: '17px', marginRight: '4px', marginLeft: '0px' }} className='veg-nonveg' src={Images.vegan} alt='vegan' />
                    </Stack>
                  ) : (
                    <img className='veg-nonveg' src={product?.foodType === 'VEG' ? Images.veg : (product?.foodType === 'VEGAN' ? Images.vegan : Images.nonVeg)} alt={product?.foodType === 'VEG' ? 'veg' : (product?.foodType === 'VEGAN' ? 'vegan' : 'non-veg')} />
                  )}
                </>
                {bestCouponDisplay?.type === "coupon" ? (
                  <>
                    <span className="productOfferprice">
                      ₹{product?.newOfferPrice}
                    </span>
                  </>
                ) : (
                  <span style={{ textDecoration: 'line-through' }} className="productOfferprice">
                    ₹{product?.newMrp}
                  </span>
                )}
              </Box>

              {isFetchingBestCoupon ?
                (
                  <Grid item xs={12} className="bestCoupon">
                    <Box className="bestCouponBox">
                      <BestCouponSkeleton />
                    </Box>
                  </Grid>
                ) : (
                  <Box item xs={12} className="bestCoupon">
                    {bestCouponDisplay && (
                      <Box
                        className="bestCouponBox"
                        display="flex"
                      >
                        <Typography
                          className="bestCouponAmount"
                          sx={{ color: theme.amount }}
                        >
                          ₹{bestCouponDisplay.displayPrice}
                        </Typography>

                        <Typography
                          className="bestPercentageOff"
                          sx={{
                            color: theme.offText,
                            backgroundColor: theme.offBg,
                          }}
                        >
                          {bestCouponDisplay.type === "coupon" ? (
                            bestCouponDisplay.offLabel
                          ) : (
                            <>
                              <span style={{ textTransform: "capitalize", marginRight: "4px" }}>
                                Save
                              </span>
                              ₹{product?.newOfferPrice?.toFixed(0)}
                            </>
                          )}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}
            </Box>

            {bestCouponDisplay ? (
              <Typography className="bestCouponCode">with {coupon?.couponCode} coupon!</Typography>
            ) : (
              <Typography className="bestCouponCode">No coupon required!</Typography>
            )}

          </Grid>
        </Grid>
      </Hidden>

      <Hidden smDown>
        <Grid container className="productBox" justifyContent={'center'}>
          <Grid item md={12}>
            <Box className="imageBox" onClick={() => handleProductClick(product)}>
              <img className="image" onClick={() => handleProductClick(product)} src={product?.displayImageUrl} alt="Product" onError={(e) => { e.target.onerror = null; e.target.src = Images.xpanseNavLogo; }} />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography className="productName">{product?.name}</Typography>

            <Box display={'flex'} justifyContent={'space-between'} alignContent={'center'}>

              <Box className="productPrice">
                <>
                  {product?.foodType === 'VEG/VEGAN' ? (
                    <Stack direction={'row'}>
                      <img className='veg-nonveg' src={Images.veg} alt='veg' />
                      <img style={{ marginRight: '4px', marginLeft: '0px' }} className='veg-nonveg' src={Images.vegan} alt='vegan' />
                    </Stack>
                  ) : (
                    <img className='veg-nonveg' src={product?.foodType === 'VEG' ? Images.veg : (product?.foodType === 'VEGAN' ? Images.vegan : Images.nonVeg)} alt={product?.foodType === 'VEG' ? 'veg' : (product?.foodType === 'VEGAN' ? 'vegan' : 'non-veg')} />
                  )}
                </>
                {bestCouponDisplay?.type === "coupon" ? (
                  <>
                    <span className="productOfferprice">
                      ₹{product?.newOfferPrice}
                    </span>
                  </>
                ) : (
                  <span style={{ textDecoration: 'line-through' }} className="productOfferprice">
                    ₹{product?.newMrp}
                  </span>
                )}
              </Box>

              {isFetchingBestCoupon ?
                (
                  <Grid xs={12} className="bestCoupon">
                    <Box className="bestCouponBox">
                      <BestCouponSkeleton />
                    </Box>
                  </Grid>
                ) : (
                  <Box className="bestCoupon">
                    {bestCouponDisplay && (
                      <Box
                        className="bestCouponBox"
                        display="flex"
                      >
                        <Typography
                          className="bestCouponAmount"
                          sx={{ color: theme.amount }}
                        >
                          ₹{bestCouponDisplay.displayPrice}
                        </Typography>

                        <Typography
                          className="bestPercentageOff"
                          sx={{
                            color: theme.offText,
                            backgroundColor: theme.offBg,
                          }}
                        >
                          {bestCouponDisplay.type === "coupon" ? (
                            bestCouponDisplay.offLabel
                          ) : (
                            <>
                              <span style={{ textTransform: "capitalize", marginRight: "4px" }}>
                                Save
                              </span>
                              ₹{bestCouponDisplay?.saveAmount.toFixed(0)}
                            </>
                          )}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}
            </Box>

            {bestCouponDisplay?.type === "coupon" ? (
              <Typography className="bestCouponCode">with {coupon?.couponCode} coupon!</Typography>
            ) : (
              <Typography className="bestCouponCode">No coupon required!</Typography>
            )}

          </Grid>
          {/* <Grid item md={12} display={'flex'} justifyContent="center" alignItems="center">
            <>
              {quantityInCart > 0 ? (
                <Box className="addedBtn" onClick={() => handleProductClick(product)}>
                  Added
                  <Box className="addedNumber">
                    {quantityInCart}
                  </Box>
                </Box>
              ) : (
                <Box className={product?.isExhausted ? "exhaustedBtn" : "notAddedBtn"} onClick={!product?.isExhausted ? () => handleProductClick(product) : null}>
                  {product?.isExhausted ?
                    <>
                      <Typography className="exhaustedText">Out Of Stock</Typography>
                    </> :
                    <>
                      <Box sx={{ display: 'flex' }}>
                        <Typography>ADD</Typography>
                        <KeyboardArrowRight className="arrowBtn" />
                      </Box>
                    </>
                  }
                </Box>
              )}
            </>
          </Grid> */}
        </Grid>
      </Hidden>
    </Box>
  );
};

export default ProductCard;